import { Stack } from "@mui/material";
import MenuLink from "./MenuLink";
import { language } from "../../../../language/strings";

interface LinksProps {

};

export default function Links(props: LinksProps) {
    return <Stack direction="row" spacing={2} >
        <MenuLink name={language.menu.home} link="home" />
        <MenuLink name={language.menu.about} link="about" />
        <MenuLink name={language.menu.photos} link="photos" />
        <MenuLink name={language.menu.contact} link="contact" />
    </Stack>
}